var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkedSolidLargeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.61023C14.0243 2.61023 12 4.63448 12 7.11023C12 7.85423 12.2872 8.61323 12.6562 9.45398C13.0253 10.2947 13.491 11.1859 13.9688 12.0087C14.9235 13.6549 15.8906 15.0321 15.8906 15.0321L16.5 15.9227L17.1094 15.0321C17.1094 15.0321 18.0758 13.6549 19.0312 12.0087C19.509 11.1852 19.9748 10.2947 20.3438 9.45398C20.7127 8.61323 21 7.85423 21 7.11023C21 4.63448 18.9757 2.61023 16.5 2.61023ZM8.97656 4.06335L3 6.61804V21.0087L9.02344 18.4071L15.0234 20.6571L21 18.1024V11.5634C20.5222 12.4806 19.992 13.3592 19.5 14.1415V17.118L15.75 18.7118V17.493L14.6484 15.8993C14.5314 15.729 14.3933 15.5271 14.25 15.3134V18.7821L9.75 17.0946V5.93835L10.5703 6.24304C10.6438 5.73604 10.7752 5.24742 10.9688 4.78992L8.97656 4.06335ZM16.5 4.11023C18.1643 4.11023 19.5 5.44598 19.5 7.11023C19.5 7.40048 19.3189 8.0856 18.9844 8.8446C18.6506 9.6036 18.1785 10.4644 17.7188 11.2587C17.1068 12.3132 16.8427 12.6894 16.5 13.2054C16.1573 12.6894 15.8932 12.3132 15.2812 11.2587C14.8215 10.4644 14.3501 9.6036 14.0156 8.8446C13.6819 8.0856 13.5 7.40048 13.5 7.11023C13.5 5.44598 14.8357 4.11023 16.5 4.11023ZM8.25 5.98523V17.118L4.5 18.7118V7.60242L8.25 5.98523Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkedSolidLargeIcon);
export default __webpack_public_path__ + "static/media/mapMarkedSolidLargeIcon.5d7f26b7c9abf337e997eb99197dc1bd.svg";
export { ForwardRef as ReactComponent };